import { apiUrl } from "./path";
import { Request } from "@/axios/request";

//  首层登录
export function login(data) {
  return Request.post(apiUrl("auth/login"), data);
}

//  首层退出（暂无用）
export function logout() {
  return Request.post(apiUrl("auth/logout"));
}

//  个人中心登录、注册
export function userCenteredRegistLogin(path, data) {
  return Request.post(apiUrl(path), data);
}

//  个人中心退出
export function userCenteredLogout() {
  return Request.post(apiUrl("auth/logout"));
}

//  获取个人信息
export function getUserProfile() {
  return Request.get(apiUrl("profile"));
}

// 修改个人信息
export function reviseUserProfile(data) {
  return Request.put(apiUrl("profile"), data);
}

//  上传用户头像
export function uploadAvatar(id, data) {
  return Request.post(apiUrl(`profile/${id}/avatar`), data);
}

//  点赞
export function likes(data) {
  return Request.post(apiUrl("medias/like"), data);
}

//  下载
export function downloads(data) {
  return Request.post(apiUrl("medias/downloads"), data);
}

//  获得tags
export function tags() {
  return Request.get(apiUrl("tags"));
}

// 获得收藏夹列表
export function getFavorites(data) {
  return Request.get(apiUrl("favorites"), { params: data });
}

// 获得收藏作品列表
export function getFavoritesMedias(data) {
  return Request.get(apiUrl("favorites/medias"), { params: data });
}

//  新建收藏夹
export function createFavorites(data) {
  return Request.post(apiUrl("favorites"), data);
}

//  修改收藏夹
export function editFavoritesName(id, data) {
  return Request.put(apiUrl(`favorites/${id}`), data);
}

// 取消图片收藏
export function cancelPictureFavorite(data) {
  return Request.delete(apiUrl("favorites/media"), { params: data });
}

//  删除收藏夹
export function removeFavorites(id) {
  return Request.delete(apiUrl(`favorites/${id}`));
}
